import React from 'react';
import { ecsExperimentationFramework } from './experimentation-framework';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { getEnv } from './services/env-service';
import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from './services/queryClient';
import { Provider } from 'react-redux';
import App from './App';
import { GrowthBookProvider } from '@growthbook/growthbook-react';
import createStore from 'store';

const initialState = window.INITIAL_STATE || {};
const store = createStore(initialState);
delete window.INITIAL_STATE;

export default function AppWithProvider() {
  return (
    <GrowthBookProvider growthbook={ecsExperimentationFramework}>
      <GoogleOAuthProvider clientId={getEnv('REACT_APP_GOOGLE_CLIENT_ID')}>
        <QueryClientProvider client={queryClient}>
          <Provider store={store}>
            <App store={store} />
          </Provider>
        </QueryClientProvider>
      </GoogleOAuthProvider>
    </GrowthBookProvider>
  );
}
